var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": 'Products & Services Matches'
    }
  }), _c('router-link', {
    attrs: {
      "to": {
        name: 'tool-list'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4'
    }
  }, [_vm._v(" Back to All Products & Services ")])], 1)], 1)], 1), _c('section', {
    staticClass: "section section-blog pt-0 mt-3"
  }, [_c('div', {
    staticClass: "container-fluid px-xs-1 px-sm-1 px-md-5 px-lg-5 px-xl-5",
    class: _vm.containerWidthClass
  }, [_c('article', {
    staticClass: "container-boundary"
  }, [_c('div', {
    staticClass: "row row-header w-100 m-0"
  }, [_c('div', {
    staticClass: "col-12 p-0"
  }, [_c('div', {
    staticClass: "row h-100 w-100 mt-0 ml-0"
  }, [_c('div', {
    staticClass: "h-100 col-2 left-row-header"
  }), _c('div', {
    staticClass: "h-100 col-10"
  }, [_c('div', {
    staticClass: "row mt-1 w-100 h-100"
  }, _vm._l(_vm.items, function (tool) {
    return _c('div', {
      key: tool.id,
      staticClass: "col h-100 d-flex flex-column justify-content-center"
    }, [_c('div', {
      staticClass: "d-flex justify-content-center align-items-center",
      staticStyle: {
        "height": "50%"
      }
    }, [_c('img', {
      staticClass: "tool-icon",
      attrs: {
        "src": tool === null || tool === void 0 ? void 0 : tool.mainImage,
        "alt": tool === null || tool === void 0 ? void 0 : tool.photoDescription
      }
    })]), _c('div', {
      staticClass: "d-flex justify-content-center align-items-center text-center text-content",
      staticStyle: {
        "height": "50%"
      }
    }, [_c('div', {
      staticClass: "flex-container title-container"
    }, [_c('p', {
      staticClass: "m-0 clipped-text flex-center title-text"
    }, [_vm._v(" " + _vm._s(tool.toolCreatedBy) + " ")])])])]);
  }), 0)])])])]), _c('div', {
    staticClass: "row row-body w-100 m-0"
  }, [_c('div', {
    staticClass: "col-12 p-0"
  }, [_c('div', {
    staticClass: "row h-100 w-100 mt-0 ml-0"
  }, [_c('div', {
    staticClass: "h-100 col-2 d-flex justify-content-center align-items-center row-title text-content"
  }, [_vm._v(" Tool Created By ")]), _c('div', {
    staticClass: "h-100 col-10"
  }, [_c('div', {
    staticClass: "row w-100 h-100 mt-0 ml-0"
  }, _vm._l(_vm.items, function (tool) {
    return _c('div', {
      key: tool.id,
      staticClass: "col h-100 d-flex flex-column justify-content-center align-items-center text-center text-content"
    }, [_vm._v(" " + _vm._s(tool.title) + " ")]);
  }), 0)])])])]), _c('div', {
    staticClass: "row row-body w-100 m-0"
  }, [_c('div', {
    staticClass: "col-12 p-0"
  }, [_c('div', {
    staticClass: "row h-100 w-100 mt-0 ml-0"
  }, [_c('div', {
    staticClass: "h-100 col-2 d-flex justify-content-center align-items-center row-title text-content"
  }, [_vm._v(" Website ")]), _c('div', {
    staticClass: "h-100 col-10"
  }, [_c('div', {
    staticClass: "row w-100 h-100 mt-0 ml-0"
  }, _vm._l(_vm.items, function (tool) {
    return _c('div', {
      key: tool.id,
      staticClass: "col h-100 text-content clipped-website-text cell-padding-text"
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": tool === null || tool === void 0 ? void 0 : tool.toolWebsite
      }
    }, [_vm._v(_vm._s(tool.toolCreatedBy))])]);
  }), 0)])])])]), _c('div', {
    staticClass: "row row-body w-100 m-0"
  }, [_c('div', {
    staticClass: "col-12 p-0"
  }, [_c('div', {
    staticClass: "row h-100 w-100 mt-0 ml-0"
  }, [_c('div', {
    staticClass: "h-100 col-2 d-flex justify-content-center align-items-center row-title text-content"
  }, [_vm._v(" Ease Of Use ")]), _c('div', {
    staticClass: "h-100 col-10"
  }, [_c('div', {
    staticClass: "row w-100 h-100 mt-0 ml-0"
  }, _vm._l(_vm.items, function (tool) {
    return _c('div', {
      key: tool.id,
      staticClass: "col h-100 d-flex flex-column justify-content-center align-items-center text-content"
    }, [_vm._v(" " + _vm._s(tool === null || tool === void 0 ? void 0 : tool.toolEaseOfUse) + " ")]);
  }), 0)])])])]), _c('div', {
    staticClass: "row row-body w-100 m-0"
  }, [_c('div', {
    staticClass: "col-12 p-0"
  }, [_c('div', {
    staticClass: "row h-100 w-100 mt-0 ml-0"
  }, [_c('div', {
    staticClass: "h-100 col-2 d-flex justify-content-center align-items-center row-title text-content"
  }, [_vm._v(" Cost Model ")]), _c('div', {
    staticClass: "h-100 col-10"
  }, [_c('div', {
    staticClass: "row w-100 h-100 mt-0 ml-0"
  }, _vm._l(_vm.items, function (tool) {
    return _c('div', {
      key: tool.id,
      staticClass: "col h-100 d-flex flex-column justify-content-center align-items-center text-content"
    }, [_vm._v(" " + _vm._s(tool === null || tool === void 0 ? void 0 : tool.toolCostModel) + " ")]);
  }), 0)])])])]), _c('div', {
    staticClass: "row row-body w-100 m-0"
  }, [_c('div', {
    staticClass: "col-12 p-0"
  }, [_c('div', {
    staticClass: "row h-100 w-100 mt-0 ml-0"
  }, [_c('div', {
    staticClass: "h-100 col-2 d-flex justify-content-center align-items-center row-title text-content"
  }, [_vm._v(" Typical Users ")]), _c('div', {
    staticClass: "h-100 col-10"
  }, [_c('div', {
    staticClass: "row w-100 h-100 mt-0 ml-0"
  }, _vm._l(_vm.items, function (tool) {
    return _c('div', {
      key: tool.id,
      staticClass: "col h-100 d-flex flex-column justify-content-center align-items-center text-content"
    }, [_vm._v(" " + _vm._s(tool === null || tool === void 0 ? void 0 : tool.toolTypicalUsers) + " ")]);
  }), 0)])])])]), _c('div', {
    staticClass: "row row-body w-100 m-0"
  }, [_c('div', {
    staticClass: "col-12 p-0"
  }, [_c('div', {
    staticClass: "row h-100 w-100 mt-0 ml-0"
  }, [_c('div', {
    staticClass: "h-100 col-2 d-flex justify-content-center align-items-center row-title text-content"
  }, [_vm._v(" Description ")]), _c('div', {
    staticClass: "h-100 col-10 mb-3"
  }, [_c('div', {
    staticClass: "row w-100 h-100 mt-0 ml-0"
  }, _vm._l(_vm.items, function (tool) {
    return _c('div', {
      key: tool.id,
      staticClass: "col h-100 d-flex flex-column justify-content-start align-items-center text-description"
    }, [_vm._v(" " + _vm._s(tool === null || tool === void 0 ? void 0 : tool.headLine) + " ")]);
  }), 0)])])])]), _c('div', {
    staticClass: "row row-body w-100 m-0"
  }, [_c('div', {
    staticClass: "col-12 p-0"
  }, [_c('div', {
    staticClass: "row h-100 w-100 mt-0 ml-0"
  }, [_c('div', {
    staticClass: "h-100 col-2 d-flex justify-content-center align-items-center text-center row-title text-content"
  }, [_vm._v(" Free Training Resources ")]), _c('div', {
    staticClass: "h-100 col-10"
  }, [_c('div', {
    staticClass: "row w-100 h-100 mt-0 ml-0"
  }, _vm._l(_vm.items, function (tool) {
    return _c('div', {
      key: tool.id,
      staticClass: "col h-100 d-flex flex-column justify-content-center align-items-center"
    }, [(tool === null || tool === void 0 ? void 0 : tool.toolFreeTrainingResourcesAvailable) === 'true' ? _c('font-awesome-icon', {
      staticClass: "pl-1",
      attrs: {
        "size": "lg",
        "icon": ['fas', 'check-circle']
      }
    }) : _c('font-awesome-icon', {
      staticClass: "pl-1",
      attrs: {
        "size": "lg",
        "icon": ['fas', 'times-circle']
      }
    })], 1);
  }), 0)])])])]), _c('div', {
    staticClass: "row row-body w-100 m-0"
  }, [_c('div', {
    staticClass: "col-12 p-0"
  }, [_c('div', {
    staticClass: "row h-100 w-100 mt-0 ml-0"
  }, [_c('div', {
    staticClass: "h-100 col-2 d-flex justify-content-center align-items-center text-center row-title text-content"
  }, [_vm._v(" Paid Training Resources ")]), _c('div', {
    staticClass: "h-100 col-10"
  }, [_c('div', {
    staticClass: "row w-100 h-100 mt-0 ml-0"
  }, _vm._l(_vm.items, function (tool) {
    return _c('div', {
      key: tool.id,
      staticClass: "col h-100 d-flex flex-column justify-content-center align-items-center"
    }, [(tool === null || tool === void 0 ? void 0 : tool.toolPaidTraining) === 'true' ? _c('font-awesome-icon', {
      staticClass: "pl-1",
      attrs: {
        "size": "lg",
        "icon": ['fas', 'check-circle']
      }
    }) : _c('font-awesome-icon', {
      staticClass: "pl-1",
      attrs: {
        "size": "lg",
        "icon": ['fas', 'times-circle']
      }
    })], 1);
  }), 0)])])])]), _c('div', {
    staticClass: "row row-body w-100 m-0"
  }, [_c('div', {
    staticClass: "col-12 p-0"
  }, [_c('div', {
    staticClass: "row h-100 w-100 mt-0 ml-0"
  }, [_c('div', {
    staticClass: "h-100 col-2 d-flex justify-content-center align-items-center row-title text-content"
  }, [_vm._v(" Related Certificates ")]), _c('div', {
    staticClass: "h-100 col-10 mb-3"
  }, [_c('div', {
    staticClass: "row w-100 h-100 mt-0 ml-0"
  }, _vm._l(_vm.items, function (tool) {
    var _tool$toolRelatedCert, _tool$toolRelatedCert2;
    return _c('div', {
      key: tool.id,
      staticClass: "col h-100 d-flex flex-column justify-content-start align-items-center"
    }, [(tool === null || tool === void 0 ? void 0 : (_tool$toolRelatedCert = tool.toolRelatedCertifications) === null || _tool$toolRelatedCert === void 0 ? void 0 : _tool$toolRelatedCert.certification.length) > 0 ? _c('b-list-group', {
      staticStyle: {
        "width": "100%"
      }
    }, _vm._l(tool === null || tool === void 0 ? void 0 : (_tool$toolRelatedCert2 = tool.toolRelatedCertifications) === null || _tool$toolRelatedCert2 === void 0 ? void 0 : _tool$toolRelatedCert2.certification, function (cert) {
      return _c('b-list-group-item', {
        key: cert,
        staticClass: "text-description"
      }, [_vm._v(" " + _vm._s(cert) + " ")]);
    }), 1) : _c('b-list-group', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('b-list-group-item', {
      staticClass: "text-description"
    }, [_vm._v("None")])], 1)], 1);
  }), 0)])])])]), _c('div', {
    staticClass: "row row-body w-100 m-0"
  }, [_c('div', {
    staticClass: "col-12 p-0"
  }, [_c('div', {
    staticClass: "row h-100 w-100 mt-0 ml-0"
  }, [_c('div', {
    staticClass: "h-100 col-2 d-flex justify-content-center align-items-center row-title text-content"
  }, [_vm._v(" Known Clients ")]), _c('div', {
    staticClass: "h-100 col-10 mb-3"
  }, [_c('div', {
    staticClass: "row w-100 h-100 mt-0 ml-0"
  }, _vm._l(_vm.items, function (tool) {
    var _tool$toolKnownClient, _tool$toolKnownClient2;
    return _c('div', {
      key: tool.id,
      staticClass: "col h-100 d-flex flex-column justify-content-start align-items-center"
    }, [(tool === null || tool === void 0 ? void 0 : (_tool$toolKnownClient = tool.toolKnownClients) === null || _tool$toolKnownClient === void 0 ? void 0 : _tool$toolKnownClient.knownClient.length) > 0 ? _c('b-list-group', {
      staticStyle: {
        "width": "100%"
      }
    }, _vm._l(tool === null || tool === void 0 ? void 0 : (_tool$toolKnownClient2 = tool.toolKnownClients) === null || _tool$toolKnownClient2 === void 0 ? void 0 : _tool$toolKnownClient2.knownClient, function (client) {
      return _c('b-list-group-item', {
        key: client,
        staticClass: "text-description"
      }, [_vm._v(" " + _vm._s(client) + " ")]);
    }), 1) : _c('b-list-group', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('b-list-group-item', {
      staticClass: "text-description"
    }, [_vm._v("None")])], 1)], 1);
  }), 0)])])])])])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }